export enum endpoints {
  COMPANY = 'companies',
  CUSTOMER = 'customers',
  CUSTOMER_PRODUCT = 'customer-products',
  PRODUCT = 'products',
  USER = 'users',
  SYSTEM_STATUS = 'SystemStatus',
  TRANSACTION = 'transactions',
}
